module.exports = __webpack_public_path__ + "212a5edb24a853792981ec4619e09cff.otf";